import { defineMessages } from 'utils/intl';

export default defineMessages({
  header: 'Masz pytania o nowoczesne technologie w edukacji?',
  description:
    'Skontaktuj się z nami i odkryj, jak łatwo wprowadzić innowacje do Twojej szkoły. Razem zbudujemy cyfrową przyszłość uczniów. Nasz zespół chętnie doradzi i pomoże w wyborze najlepszych rozwiązań dla Twojej szkoły.',
  button: 'Napisz do nas',
  phone: 'lub zadzwoń {phone}',
});
